(function () {
  'use strict';

  /* ---------- Mobile nav drawer ---------- */
  function initNavDrawer() {
    var drawer = document.querySelector('[data-nav-drawer]');
    if (!drawer) return;

    var openBtns = document.querySelectorAll('[data-nav-open]');
    var closeEls = drawer.querySelectorAll('[data-nav-close]');

    function setOpen(open) {
      drawer.setAttribute('data-open', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
      openBtns.forEach(function (b) {
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    openBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        setOpen(true);
      });
    });
    closeEls.forEach(function (b) {
      b.addEventListener('click', function () {
        setOpen(false);
      });
    });
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
  }

  /* ---------- Product: variant select updates price + button ---------- */
  function initProductForm() {
    var select = document.querySelector('[data-variant-select]');
    var priceEl = document.querySelector('[data-product-price]');
    var submitBtn = document.querySelector('[data-add-to-cart]');
    if (!select) return;

    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      if (priceEl && opt.getAttribute('data-price')) {
        priceEl.textContent = opt.getAttribute('data-price');
      }
      if (submitBtn) {
        var soldOut = opt.getAttribute('data-available') === 'false';
        submitBtn.disabled = soldOut;
        submitBtn.textContent = soldOut
          ? submitBtn.getAttribute('data-sold-out-text') || 'Sold Out'
          : submitBtn.getAttribute('data-default-text') || 'Add to Cart';
      }
    });
  }

  /* ---------- Product gallery thumbnails ---------- */
  function initGallery() {
    var main = document.querySelector('[data-gallery-main] img');
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (full) main.src = full;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initNavDrawer();
    initProductForm();
    initGallery();
  });
})();
